import axios from 'axios';
import { getSession } from './auth.service';

const instance = axios.create({
  baseURL: process.env.REACT_APP_PDF_SERVICE_API_URL,
  // headers: {
  //   'x-api-key': process.env.REACT_APP_PDF_SERVICE_API_KEY,
  //   'Content-Type': 'application/json',
  // },
});

export async function generatePDFPresignedURL(data, template) {
  const { idToken } = await getSession();
  return instance.request({
    url: `/api/v1/templates/${template}%23es/render/pdf`,
    method: 'post',
    data: { ...data },
    headers: {
      'x-api-key': idToken?.jwtToken,
    },
  });
}

export async function downloadPDF(payload, template) {
  const { data } = await generatePDFPresignedURL(payload, template);
  const { url } = data || {};
  const downloadWindow = window.open(url, '_blank');
  downloadWindow?.focus();
}
